// insight ฝังในหน้าจอ: ข้อมูลการซื้อของลูกค้าที่เลือก (แสดงใต้ช่องเลือกลูกค้า) — ไม่แสดงอะไรถ้าผู้ใช้ไม่ได้เปิดใช้หรือไม่มีข้อมูล
import React from 'react';
import { Box, Typography } from '@mui/material';
import InsightsIcon from '@mui/icons-material/Insights';
import { useInlineCustomer } from './useInsightInline';
import { money } from './format';

const THAI_MONTHS = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];
const shortDate = iso => {
  const [, m, d] = String(iso).split('-').map(Number);
  return `${d} ${THAI_MONTHS[m - 1]}`;
};

function changeText(change) {
  const pct = Math.round(Math.abs(change) * 100);
  return change < 0 ? `ต่ำกว่าปกติ${pct >= 50 ? 'มาก' : ''} (−${pct}%)` : `สูงกว่าปกติ (+${pct}%)`;
}

export default function InlineCustomerNote({ custCode }) {
  const card = useInlineCustomer(custCode);
  if (!card) return null;
  const { buy, drop } = card;
  const parts = [];
  if (buy) {
    parts.push(`โอกาสซื้อใน 7 วัน ${Math.round(buy.p * 100)}% (ลูกค้าทั่วไป ${Math.round(buy.base * 100)}%)`);
    if (buy.everyDays) parts.push(`ปกติซื้อทุก ~${buy.everyDays} วัน`);
    if (buy.typicalAmount) parts.push(`ครั้งละ ~${money(buy.typicalAmount)}`);
    parts.push(`ซื้อล่าสุด ${shortDate(buy.lastDate)}`);
  }
  return (
    <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'flex-start', mt: 0.25 }}>
      <InsightsIcon sx={{ fontSize: 14, color: 'primary.main', mt: '2px' }} />
      <Box>
        {parts.length > 0 && (
          <Typography variant="caption" color="text.secondary" display="block" lineHeight={1.4}>{parts.join(' · ')}</Typography>
        )}
        {drop && (
          <Typography variant="caption" display="block" lineHeight={1.4} sx={{ color: '#e65100' }}>
            ยอด 28 วันล่าสุด {money(drop.current)} {changeText(drop.change)} — ปกติ ~{money(drop.normal)} ต่อ 28 วัน
          </Typography>
        )}
      </Box>
    </Box>
  );
}
